<template>
  <pa-header></pa-header>
  <div class="text-center flex items-center justify-center py-40" v-if="loading">
    <div class="lds-ripple">
      <div></div>
    </div>
    Loading please wait...
  </div>
  <div class="container-fluid">
    <div v-for="(show,index) in shows" v-bind:key="index">
      <VideoRow :show="show"></VideoRow>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import PaHeader from "@/views/Pa-Header";
import VideoRow from "@/views/Video-Row.vue";

var SpatialNavigation = window.SpatialNavigation;

export default {
  components: {VideoRow, PaHeader},
  data() {
    return {
      videos: [],
      shows: [],
      loading: false
    }
  },
  methods: {
    openVideo(vid) {
      this.$router.push({
        name: "pa-youtube", //use name for router push
        params: {id: vid}
      });
    }
  },
  mounted() {
    var el = document.querySelectorAll('.router-link-exact-active')[0];
    if (el) el.classList.add('active');
    SpatialNavigation.focus('.router-link-exact-active');
    this.loading = true;

    axios.get('https://roosterapi.patv.in/api/videos')
        .then((res) => {
          this.$data.shows = [...res.data];
          SpatialNavigation.makeFocusable();
          SpatialNavigation.focus();
          // SpatialNavigation.focus(e.target)
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false;
        });
  }
}
</script>
